export default __webpack_public_path__ + "static/media/image-cover.3d5facb7.jpg";